import * as React from "react";

export const CameraIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 60 60" {...props}>
    <path d="M30 20.5c-6.617 0-12 5.383-12 12s5.383 12 12 12 12-5.383 12-12-5.383-12-12-12z" />
    <path d="M55.201 15.5h-8.524l-4-10H17.323l-4 10H12v-5H6v5H4.799A4.803 4.803 0 000 20.299v29.368A4.838 4.838 0 004.833 54.5h50.334A4.838 4.838 0 0060 49.667V20.299a4.803 4.803 0 00-4.799-4.799zM10 15.5H8v-3h2v3zm20 35c-9.925 0-18-8.075-18-18s8.075-18 18-18 18 8.075 18 18-8.075 18-18 18zm22-23c-2.206 0-4-1.794-4-4s1.794-4 4-4 4 1.794 4 4-1.794 4-4 4z" />
  </svg>
);
